import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/home';
import Kontakt from './pages/kontakt';
import Om_oss from './pages/om-oss';
import Flyttstad from './pages/flyttstadning'; // Importera Flyttstad
import Fonsterputs from './pages/fonsterputs'; // Importera Flyttstad
import FlyttstadningIStockholm from './pages/flyttstadning-i-stockholm'; // Importera din nya komponent
import FlyttstadningIStrangnas from './pages/flyttstadning-i-strangnas'; // Importera din nya komponent
import FlyttstadningIEskilstuna from './pages/flyttstadning-i-eskilstuna'; // Importera din nya komponent
import Trappstadning from './pages/trappstadning'; // Importera din nya komponent
import Kontorsstadning from './pages/kontorsstadning'; // Importera din nya komponent
import Byggstadning from './pages/byggstadning'; // Importera din nya komponent
import Lokalvard from './pages/lokalvard'; // Importera din nya komponent
import Tradgardsskotsel from './pages/tradgardsskotsel'; // Importera din nya komponent
import Plantering from './pages/plantering'; // Importera din nya komponent
import Lovblasning from './pages/lovblasning'; // Importera din nya komponent
import Vinterunderhall from './pages/vinterunderhall'; // Importera din nya komponent
import BookingForm from './pages/bookingform'; // Importera din nya komponent
import ThankYou from './pages/thank-you'; // Importera din nya komponent
import PrivacyPolicy from './pages/integritetspolicy'; // Importera din nya komponent
import Arbetspolicy from './pages/arbetspolicy'; // Importera din nya komponent
import NotFound from './pages/not-found'; // Importera din nya komponent


function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-oss" element={<Om_oss />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/boka" element={<BookingForm />} />
          <Route path="/tack" element={<ThankYou />} />
          <Route path="/integritetspolicy" element={<PrivacyPolicy />} />
          <Route path="/arbetspolicy" element={<Arbetspolicy />} />
          <Route path="/stad/flyttstadning" element={<Flyttstad />} /> 
          <Route path="/stad/fonsterputs" element={<Fonsterputs />} /> 
          <Route path="/stad/trappstadning" element={<Trappstadning />} /> 
          <Route path="/stad/kontorsstadning" element={<Kontorsstadning />} /> 
          <Route path="/stad/byggstadning" element={<Byggstadning />} /> 
          <Route path="/stad/lokalvard" element={<Lokalvard />} /> 
          <Route path="/stad/flyttstadning-i-stockholm" element={<FlyttstadningIStockholm />} />
          <Route path="/stad/flyttstadning-i-strangnas" element={<FlyttstadningIStrangnas />} />
          <Route path="/stad/flyttstadning-i-eskilstuna" element={<FlyttstadningIEskilstuna />} />
          <Route path="/tradgard/tradgardsskotsel" element={<Tradgardsskotsel />} />
          <Route path="/tradgard/plantering" element={<Plantering />} />
          <Route path="/tradgard/lovblasning" element={<Lovblasning />} />
          <Route path="/tradgard/vinterunderhall" element={<Vinterunderhall />} />
          <Route path="*" element={<NotFound />} /> {/* Fångar alla odefinierade routes */}


        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
